module.exports = __webpack_public_path__ + "static/presidents-message-bb92a254f237a66655f41c9f5ca9e5bd.jpg";